import { makeStyles } from '@material-ui/core/styles';

export const modalUpdatePersonalDataStyles = makeStyles((theme) => ({
  paper: {
    width: (props) => (props.mobile ? '' : 600),
    margin: 8,
    borderRadius: 4,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  buttonsContainer: {
    margin: 'auto !important',
    paddingBottom: 25,
  },
  updatePersonalDataButton: {
    marginTop: 20,
    marginBottom: 30,
  },
  updateAddressesButton: {
    marginBottom: 40,
  },
  normalText: {
    textAlign: 'center',
    color: '#464646',
    padding: '0px 24px',
  },
  title: {
    fontSize: 20,
    marginTop: 20,
    fontWeight: 600,
  },
  subtitle: {
    fontSize: 16,
    marginTop: 20,
  },
  purpleDetail: {
    color: '#6A148E',
    fontWeight: 500,
    fontSize: 22,
    marginTop: 12,
  },
  bodyText: {
    marginTop: (props) => (props.mobile ? 10 : 25),
    fontSize: 16,
  },
  image: {
    width: 135,
    marginBottom: 20,
  },
  imageContainer: {
    marginRight: -24,
    marginLeft: -24,
    backgroundColor: '#F6F5FB',
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  dialogActionsContainer: {
    '&.MuiDialogActions-root': {
      justifyContent: 'space-around',
    },
  },
  dialogTitleContainer: {
    backgroundColor: '#F6F5FB',
  },
}));
